export const floors = [
    { name: 'checkBox_05', label: '0.5' },
    { name: 'checkBox_1', label: '1' },
    { name: 'checkBox_15', label: '1.5' },
    { name: 'checkBox_2', label: '2' },
    { name: 'checkBox_25', label: '2.5' },
    { name: 'checkBox_3', label: '3' },
]

export const typeBuilding = [
    { name: 'Дом', label: 'Дом' },
    { name: 'Баня', label: 'Баня' },
]

export const roof = [
    { name: 'Плоская', label: 'Плоская', },
    { name: 'Односкатная', label: 'Односкатная', },
    { name: 'Двухскатная', label: 'Двухскатная', },
    { name: 'Четырехскатная', label: 'Четырехскатная', },
    { name: 'roof_Другое', label: 'Другое', },
]

export const foundation = [
    { name: 'Лента', label: 'Лента', },
    { name: 'Сваи', label: 'Сваи', },
    { name: 'Плита', label: 'Плита', },
    { name: 'Подвал', label: 'Подвал', },
    { name: 'foundation_Другое', label: 'Другое', },
]

export const material = [
    { name: 'Кирпич', label: 'Кирпич', },
    { name: 'Блоки', label: 'Блоки', },
    { name: 'Дерево', label: 'Дерево', },
    { name: 'Бетон', label: 'Бетон', },
    { name: 'material_Другое', label: 'Другое', },
]

export const concreteType = [
    { name: 'Каркас', label: 'Каркас' },
    { name: 'Монолит', label: 'Монолит' },
    { name: 'Другое', label: 'Другое' },
]

export const blockType = [
    { name: 'Пенобетон', label: 'Пено-бетон' },
    { name: 'Газобетон', label: 'Газо-бетон' },
    { name: 'Керамика', label: 'Керам' },
    { name: 'Арболит', label: 'Арболит' },
    { name: 'Другое', label: 'Другое' },
]

export const woodType = [
    { name: 'Брус', label: 'Брус' },
    { name: 'Бревно', label: 'Бревно' },
    { name: 'Каркас', label: 'Каркас' },
    { name: 'Панели', label: 'Панели' },
    { name: 'Другое', label: 'Другое' },
]

